// ---------------------------------------------------------------------------
// etaPolicy — THE ETA RULE FOR THIS RELEASE, in one place (spec item 2, Aug 11).
//
// Canonical planned ETA = route.duration. Full stop.
//
// Why this is safe to say now: the primary Mapbox requests already use the
// driving-traffic profile (routing.ts), so route.duration IS the traffic
// answer. The Aug 10–11 "44 km/h" saga ended with the raw numbers proving the
// durations were never wrong (docs/OPEN_ETA_BUG.md) — the 5h23 on a 2h01
// corridor was the positional Pleasant door putting the wrong ROUTE on the
// card, since fixed and bounded by 1.6× (2862223f). The card-side
// trafficDurationS override was restored (88b61353) on the belief that
// route.duration was inflated; f9022f06 disproved that premise, so the
// override goes — one layer was logging "second traffic estimate ignored"
// while another displayed it.
//
// The secondary traffic estimate is still POLLED (NavigationView) and may
// inform congestion detection / the "take the fastest way?" offer, but it
// does not replace the displayed ETA. Navigation's live override remains
// gated behind its own validation (distance-match + plausibility), which is
// a separate, still-correct guard.
// ---------------------------------------------------------------------------

/** The ETA a route CARD displays. The secondary estimate is accepted as an
 *  argument precisely so every caller flows through this choke point — and
 *  it is deliberately ignored. */
export function plannedCardEtaSeconds(
  engineDurationS: number,
  _secondaryTrafficS?: number | null,
): number {
  return engineDurationS;
}

/** Navigation's planned-pace ETA for the remaining distance. At trip start
 *  (distRemaining === route.distance) this equals route.duration, which is
 *  the spec's continuity requirement: a card that says 2h01 must open
 *  navigation at ≈2h01. Between traffic polls it decrements smoothly with
 *  progress. Mirrors the long-standing NavigationView fallback formula —
 *  extracted, not changed. */
export function plannedEtaRemainingSeconds(
  route: { distance: number; duration: number },
  distRemainingM: number,
): number {
  const avgSpeed =
    route.distance > 0 ? route.distance / Math.max(1, route.duration) : 1.2;
  return distRemainingM / Math.max(0.3, avgSpeed);
}
